import { render, staticRenderFns } from "./DemandSurvey.vue?vue&type=template&id=5bf9bef2&scoped=true"
import script from "./DemandSurvey.vue?vue&type=script&lang=js"
export * from "./DemandSurvey.vue?vue&type=script&lang=js"
import style0 from "./DemandSurvey.vue?vue&type=style&index=0&id=5bf9bef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf9bef2",
  null
  
)

export default component.exports